import Icon from './Icon'

export default Icon



// WEBPACK FOOTER //
// ./src/components/Icon/index.js